export const apiName: string = 'deslocamentos';
export const deslocamentosRoute: string = 'deslocamentos';
export const deslocamentosStorage: string = 'deslocamentos';
export const deslocamentosModuleName: any = {plural: 'Solicitações', single: 'Solicitação'};

export const apiNameCustosDeslocamento: string = 'custos-deslocamentos';


export const tiposDeslocamentos: any[] = [
    { "Key": 1, "Value": "Saída"},
    { "Key": 2, "Value": "Viagem"}
];

export const statusDeslocamentos: any[] = [
    { "Key": 3, "Value": "Aprovado"},
    { "Key": 1, "Value": "Solicitado"},
    { "Key": 2, "Value": "Cancelado"},
    { "Key": 4, "Value": "Concluído"}
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/shared/data.service.ts
 **/